import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// import './axios/axios'
import axios from 'axios';
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import en from './assets/i18n/en.json';
import fr from './assets/i18n/fr.json';

import './assets/js/sweetalert.js';
import 'aos/dist/aos.css';
import VueVideoPlayer from '@videojs-player/vue'
import 'video.js/dist/video-js.css'

// import 'bootstrap/dist/css/bootstrap.min.css';
// import 'bootstrap';
// import 'bootstrap-icons/font/bootstrap-icons.css';

// import { MdButton } from 'vue-material'
// import 'vue-material/dist/vue-material.min.css'

AOS.init();

import SwiperClass, { /* swiper modules... */ } from 'swiper'
import VueAwesomeSwiper from 'vue-awesome-swiper'

// import swiper module styles
import 'swiper/css'
// more module style...

// use swiper modules
SwiperClass.use([/* swiper modules... */])

import { createI18n } from 'vue-i18n';

const i18n =createI18n({
    locale: localStorage.getItem('lang') || 'en',
    messages: {
        en: en,
        fr: fr
    }
})
// import i18n from './i18n';

const lang = localStorage.getItem('lang') || 'en';
axios.defaults.baseURL = `https://backend.relibridgeminerals.com/${lang}/api/`;
// axios.defaults.baseURL = `http://192.168.2.208:8000/${lang}/api/`;

/* import the fontawesome core */
import { library } from '@fortawesome/fontawesome-svg-core'


/* import font awesome icon component */
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import VideoBackground from 'vue-responsive-video-background-player'

import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'

/* import specific icons */
import { faAddressCard, faBars, faCartShopping, faFilePen, faFire, faHouse, faHouseUser, faInfo, faKey, faRightToBracket, faScrewdriverWrench, faSquareXmark, faUser, faUserSecret } from '@fortawesome/free-solid-svg-icons'

/* add icons to the library */
library.add(faUserSecret, faCartShopping, faUser, faBars, faHouseUser, faScrewdriverWrench, faFire, faInfo, faRightToBracket, faAddressCard, faHouse, faKey, faSquareXmark,
          faFilePen,
         );
// faBars, faHouseUser, faScrewdriverWrench, faFire, faInfo
// import { inject } from 'vue'


 
// const globalVar=inject('http://192.168.2.208:8000')
// import 'vue-material/dist/vue-material.min.css'
// import 'vue-material/dist/theme/default.css'

const options = {
    // You can set your default options here
};

createApp(App)

// Optionally install the BootstrapVue icon components plugin
// .use(IconsPlugin)
.component('font-awesome-icon', FontAwesomeIcon)
.component('video-background', VideoBackground)
.component('VueDatePicker', VueDatePicker)



// .use(BootstrapVue)
// .use(IconsPlugin)
// .use(Vue3Material)
// .use(vue3videoPlay)

.use(i18n)
.use(Toast, options)
.use(store)
.use(router)
.use(VueAwesomeSwiper)
.use(VueVideoPlayer)
.mount('#app')
